import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import defaultClassNames from './classNames';
import { SPACE, ENTER } from './keys';

var Navbar = /*#__PURE__*/function () {
  var Navbar = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Navbar, _Component);

    function Navbar() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;

      _this.handleNextClick = function () {
        if (_this.props.onNextClick) {
          _this.props.onNextClick();
        }
      };

      _this.handlePreviousClick = function () {
        if (_this.props.onPreviousClick) {
          _this.props.onPreviousClick();
        }
      };

      _this.handleNextKeyDown = function (e) {
        if (e.keyCode !== ENTER && e.keyCode !== SPACE) {
          return;
        }

        e.preventDefault();

        _this.handleNextClick();
      };

      _this.handlePreviousKeyDown = function (e) {
        if (e.keyCode !== ENTER && e.keyCode !== SPACE) {
          return;
        }

        e.preventDefault();

        _this.handlePreviousClick();
      };

      return _this;
    }

    var _proto = Navbar.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    };

    _proto.render = function render() {
      var _this$props = this.props,
          classNames = _this$props.classNames,
          className = _this$props.className,
          showPreviousButton = _this$props.showPreviousButton,
          showNextButton = _this$props.showNextButton,
          labels = _this$props.labels,
          dir = _this$props.dir;
      var previousClickHandler;
      var nextClickHandler;
      var previousKeyDownHandler;
      var nextKeyDownHandler;
      var shouldShowPrevious;
      var shouldShowNext;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + " " + classNames.navButtonInteractionDisabled;
      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + " " + classNames.navButtonInteractionDisabled;
      var previousButton = /*#__PURE__*/React.createElement("span", {
        tabIndex: "0",
        role: "button",
        "aria-label": labels.previousMonth,
        key: "previous",
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });
      var nextButton = /*#__PURE__*/React.createElement("span", {
        tabIndex: "0",
        role: "button",
        "aria-label": labels.nextMonth,
        key: "right",
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className || classNames.navBar
      }, dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]);
    };

    return Navbar;
  }(Component);

  Navbar.defaultProps = {
    classNames: defaultClassNames,
    dir: 'ltr',
    labels: {
      previousMonth: 'Previous Month',
      nextMonth: 'Next Month'
    },
    showPreviousButton: true,
    showNextButton: true
  };
  return Navbar;
}();

export default Navbar;